import VoiceRepository from '@/repositories/VoiceRepository'
import PagerRepository from '@/repositories/PagerRepository'
import VoiceEntity from '@/entities/Voice'

export interface IPresenterParams {
  voiceRepository: VoiceRepository
  pagerRepository: PagerRepository
}

export interface IPresenter {
  page: number
  size: number
  total: number | null
  totalPage: number
  voices: VoiceEntity[]
}

export default ({ voiceRepository, pagerRepository }: IPresenterParams): IPresenter => {
  const { page, size, total } = pagerRepository.getVoicesPager()
  const totalPage = total ? Math.ceil(total / size) : 0
  return {
    page,
    size,
    total,
    totalPage,
    voices: voiceRepository.getVoicesByPage(page)
  }
}
